@if (localeData.supported.length > 1) {
  <button
    mat-button
    mat-stroked-button
    [color]="'primary'"
    class="revolution m-0 min-w-fit"
    [matMenuTriggerFor]="localeMenu"
  [ngClass]="{
    'border-white text-white': isMobileLogin,
  }"
    >
    {{ localeData?.current }}
    <mat-icon svgIcon="keyboard_arrow_down"></mat-icon>
  </button>
}
<mat-menu #localeMenu="matMenu" class="locale-menu">
  @for (lang of localeData.supported; track lang) {
    <a
      mat-menu-item
      [href]="lang.url"
      >{{ lang?.label }}</a
      >
    }
  </mat-menu>
